import React from "react";
import { Box, CardContent, Typography } from "@mui/material";
import { PieChart as PieChartIcon } from "@mui/icons-material";
import { StandardCard } from "../../../../components/Cards";
import { Chart } from "../../../marketingCampaign/components/Graphs/chart";
import { BarGraphSkeleton } from "../skeletons";
import {
  IFoodCard,
  IUpsellingDataItem,
  isFoodCard,
} from "../../types/upsell.types";
import { FOOD_PERFORMANCE_DONUT_OPTIONS } from "../../constants/chartOptions";
import { NoRecordFound } from "../../../../components/NoRecordFound/NoRecordFound";

interface FoodPerformanceDonutGraphProps {
  dashboardData: IUpsellingDataItem[] | null;
  height?: number | string;
}

export const FoodPerformanceDonutGraph: React.FC<
  FoodPerformanceDonutGraphProps
> = ({ dashboardData, height }) => {
  if (!dashboardData || dashboardData.length === 0) {
    return <BarGraphSkeleton />;
  }

  // Filter only venues using type guard
  const foodMenues = dashboardData.filter(isFoodCard) as IFoodCard[];

  const foodData = foodMenues.map((food) => ({
    name: food.item_name,
    leads: food.leads?.length || 0,
  }));

  // Filter out items with 0 leads to avoid clutter
  const nonZeroFood = foodData.filter((food) => food.leads > 0);

  const chartData = {
    series: nonZeroFood.map((food) => food.leads),
    labels: nonZeroFood.map((food) => food.name),
  };

  const chartOptions = {
    ...FOOD_PERFORMANCE_DONUT_OPTIONS,
    labels: chartData.labels,
  };

  return (
    <StandardCard>
      <CardContent sx={{ p: height ? 2 : 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <PieChartIcon sx={{ mr: 1, color: "primary.main" }} />
          <Typography variant="h5" fontWeight={600}>
            Food Menu Performance
          </Typography>
        </Box>
        <Box sx={{ height: height ?? 400, mt: 1 }}>
          {foodMenues.length === 0 ? (
            <NoRecordFound />
          ) : (
            <Chart
              type="donut"
              series={chartData.series}
              options={chartOptions}
              height={height ?? 500}
            />
          )}
        </Box>
      </CardContent>
    </StandardCard>
  );
};
